export const ROB_SHOW_RESET = "ROB_SHOW_RESET";
export const ROB_SHOW_SET_ERROR = "ROB_SHOW_SET_ERROR";
export const ROB_SHOW_SET_RETRIEVED = "ROB_SHOW_SET_RETRIEVED";
export const ROB_SHOW_TOGGLE_LOADING = "ROB_SHOW_TOGGLE_LOADING";
